import { NoPayload } from '../commonPayloadTypes';
import { ErrorOrCriticalPayload } from '../eventMap';

export enum ApSkipContentEvents {
    SkipContentDisplayed = 'ApSkipContentEvents.SkipContentDisplayed',
    SkipContentBluredWithoutClick = 'ApSkipContentEvents.SkipContentBluredWithoutClick',
    SkipContentClicked = 'ApSkipContentEvents.SkipContentClicked',
    SkipContentSuccess = 'ApSkipContentEvents.SkipContentSuccess',
    SkipContentQueryError = 'ApSkipContentEvents.SkipContentQueryError',
}

type SkipContentClickedPaylaod = {
    targetElement: string;
};

type SkipContentSuccess = {
    targetElement: string;
    focusedElement: string;
};

interface SkipContentQueryError extends ErrorOrCriticalPayload {
    targetElement: string;
}

export interface ApSkipContentEventMap {
    [ApSkipContentEvents.SkipContentDisplayed]: NoPayload;
    [ApSkipContentEvents.SkipContentBluredWithoutClick]: NoPayload;
    [ApSkipContentEvents.SkipContentClicked]: SkipContentClickedPaylaod;
    [ApSkipContentEvents.SkipContentSuccess]: SkipContentSuccess;
    [ApSkipContentEvents.SkipContentQueryError]: SkipContentQueryError;
}
